import { TextProps as OriginalTextProps } from '@theme-ui/components';
import { PropsWithoutRef } from 'react';

export type TextProps = PropsWithoutRef<OriginalTextProps>;

export { Text } from '@theme-ui/components';
